export function isZeroPilotPathAllowed(pathname: string): boolean {
  return (
    pathname === "/" ||
    pathname === "/knowledge-base" ||
    pathname.startsWith("/knowledge-base/")
  );
}
